import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Generate time options from 00:00 to 23:30 in 30-min steps
 */
const TIME_OPTIONS = [];
for (let h = 0; h < 24; h++) {
  for (let m = 0; m < 60; m += 30) {
    TIME_OPTIONS.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
  }
}

/**
 * TimeSlotPicker — a constrained dropdown for selecting a time.
 * No free-text. Users can ONLY pick from predefined HH:MM values.
 * 
 * Props:
 *   value: string (HH:MM or "?")
 *   onChange: (value: string) => void
 *   allowOpenEnded: boolean — if true, adds "?" as first option
 *   label: string — optional label above the picker
 *   testId: string — data-testid
 */
export const TimeSlotPicker = ({ value, onChange, allowOpenEnded = false, label, testId }) => {
  const { t } = useLanguage();
  const isOpenEnded = value === '?';

  return (
    <div>
      {label && <label className="text-[10px] text-zinc-400 block mb-0.5 font-medium">{label}</label>}
      <div className="relative">
        <select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-zinc-800 border border-zinc-600 rounded-lg px-3 py-2 text-sm font-mono appearance-none cursor-pointer focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none transition-colors"
          style={{ color: isOpenEnded ? '#f59e0b' : '#fff' }}
          data-testid={testId}
        >
          {allowOpenEnded && (
            <option value="?" className="text-amber-400">? {t('openingHoursEditor.unknownClose') || 'Ukendt lukketid'}</option>
          )}
          {TIME_OPTIONS.map(opt => (
            <option key={opt} value={opt} className="text-white">{opt}</option>
          ))}
        </select>
        <ChevronDown className="w-3.5 h-3.5 text-zinc-400 absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
      </div>
    </div>
  );
};

export default TimeSlotPicker;
